// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/* infobulle des camemberts, hors du canevas (non scopé : ajoutée au <body>) */\n.wizard-chart-infobulle {\n  position: absolute; z-index: 2000; pointer-events: none; opacity: 0;\n  transform: translate(-50%, calc(-100% - 10px));\n  background: rgba(26, 26, 46, .92); color: #fff; border-radius: 6px; padding: 6px 10px;\n  font: 12px 'Raleway', sans-serif; white-space: nowrap; transition: opacity .12s;\n}\n", ""]);
// Exports
module.exports = exports;
